export default __webpack_public_path__ + "static/media/40300.5ee7de73.jpg";